import script from "./addNewUserDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./addNewUserDialog.vue?vue&type=script&setup=true&lang=ts"

import "./addNewUserDialog.vue?vue&type=style&index=0&id=38bb0a4a&lang=scss"

const __exports__ = script;

export default __exports__